import indexOf from 'lodash/indexOf';
import head from 'lodash/head';

const getRoleLandingPage = roles => {
  const index = indexOf(roles, 'admin');

  /**
   * For users who are members NOT(referrer, affiliate, partner)
   * there is not a promo page. Thus, navigate them to settings
   */
  const userPath =
    indexOf(roles, 'member') === -1
      ? `/${head(roles)}/promo`
      : '/member/settings';

  return index === -1 ? userPath : '/admin/users';
};

export default getRoleLandingPage;
